import { render, staticRenderFns } from "./TryLiveChannel.vue?vue&type=template&id=0975403a&scoped=true&"
import script from "./TryLiveChannel.vue?vue&type=script&lang=js&"
export * from "./TryLiveChannel.vue?vue&type=script&lang=js&"
import style0 from "./TryLiveChannel.vue?vue&type=style&index=0&id=0975403a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975403a",
  null
  
)

export default component.exports